module.exports = __webpack_public_path__ + "img/b510f80c592a4e00b4e46b6cbfa4831d-1440.45508c60.jpg";